<template>
  <div>
    <div class="bg-nw-red menu-rounded-top pt-11 pb-9 pl-8">
      <div class="inline-block absolute">
        <profile-icon :width="'w-10'" :height="'h-10'" :color="'text-white'"></profile-icon>
      </div>
      <div class="inline-block text-white leading-3 pl-14 xs:pl-16" @click="profile">
        <div class="text-sm font-extrabold">
          {{ user_details ? user_details.first_name + ' ' + user_details.last_name.split('')[0] + '.' : '' }}
        </div>
        <span class="text-xxs">{{ user ? user.phoneNumber : '' }}</span>
      </div>
    </div>
    <div class="pl-8">
      <div class="pt-9" @click="dashboard">
        <dashboard-icon :width="'w-4'" :height="'h-4'"></dashboard-icon>
        <span class="font-extrabold text-white uppercase text-xs pl-6">Dashboard</span>
      </div>
      <div class="pt-8" @click="payment">
        <payment-icon :width="'w-4'" :height="'h-4'"></payment-icon>
        <span class="font-extrabold text-white uppercase text-xs pl-6">Payment Method</span>
      </div>
      <div class="pt-8" @click="history">
        <history-icon :width="'w-4'" :height="'h-4'" :color="'#f0314b'"></history-icon>
        <span class="font-extrabold text-white uppercase text-xs pl-6">Delivery History</span>
      </div>
      <!-- <div class="pt-8">
        <location-icon :width="'w-4'" :height="'h-4'"></location-icon>
        <span class="font-extrabold text-white uppercase text-xs pl-6">Favourites</span>
      </div> -->
      <div class="pt-8" @click="contact">
        <contact-icon :width="'w-4'" :height="'h-4'"></contact-icon>
        <span class="font-extrabold text-white uppercase text-xs pl-6">Contact Us</span>
      </div>
      <div class="pt-8" @click="logout">
        <logout-icon :width="'w-4'" :height="'h-4'" :color="'text-nw-red'"></logout-icon>
        <span class="font-extrabold text-white uppercase text-xs pl-6">Log Out</span>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardIcon from './icons/DashboardIcon.vue'
import PaymentIcon from './icons/PaymentIcon.vue'
// import LocationIcon from './icons/LocationIcon.vue'
import ContactIcon from './icons/ContactIcon.vue'
import HistoryIcon from './icons/HistoryIcon.vue'
import Swal from 'sweetalert2'
import LogoutIcon from './icons/LogoutIcon.vue'
import ProfileIcon from './icons/ProfileIcon.vue'

export default {
  components: {
    HistoryIcon,
    DashboardIcon,
    PaymentIcon,
    // LocationIcon,
    ContactIcon,
    LogoutIcon,
    ProfileIcon
  },
  computed: {
    user_details() {
      return this.$store.state.user_details
    },
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    profile() {
      this.$router.push({
        name: 'Profile'
      })
    },
    dashboard() {
      if (this.$route.name != 'Dashboard') {
        this.$router.push({
          name: 'Dashboard'
        })
      } else {
        this.$emit('show-menu', false)
      }
    },
    payment() {
      this.$router.push({
        name: 'Payment'
      })
    },
    history() {
      this.$router.push({
        name: 'History'
      })
    },
    contact() {
      this.$router.push({
        name: 'Contact'
      })
    },
    logout() {
      Swal.fire({
        text: 'Log Out?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        cancelButtonText: `No`
      }).then(result => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.$store.dispatch('logout')
        }
      })
    }
  }
}
</script>
